export default __webpack_public_path__ + "static/media/EcapPDFPreview.26fe6ede.jpg";